import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="map"
export default class extends Controller {

  static values = {
    annotations: Array
  }

  setup() {
    let annotations = [];

    this.annotationsValue.forEach(annotation => {
      let event = new mapkit.Coordinate(annotation.latitude, annotation.longitude);
      let eventAnnotation = new mapkit.MarkerAnnotation(event, {
        color: annotation.color || 'red',
        title: annotation.title,
      });

      annotations.push(eventAnnotation);
    });

    const map = new mapkit.Map(this.element, { colorScheme: "adaptive" });
    map.cameraDistance = 20000;

    map.showItems(annotations);
  };

}